import { timeline, positionInViewport } from '../utility/timeline.js'

function easeInQuint(x) {
	return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
}

function setVar(el, pos, ease = x => x) {
	el.style.setProperty('--scroll-position', `${ease(pos.percent).toFixed(5)}`)
}

function setupTimeline(el) {
	const tl = timeline({
		beforeCalc: () => document.documentElement.classList.add('disable-scroll-cards'),
		afterCalc: () => document.documentElement.classList.remove('disable-scroll-cards'),
		start: () => positionInViewport(el, { elementY: 0, viewportY: 1 }).y,
		end: () => positionInViewport(el, { elementY: 1, viewportY: 0 }).y
	})
	const ease = el.getAttribute('data-scroll-position-ease') !== null
	tl.onUpdate((pos, details) => setVar(el, pos, ease ? easeInQuint : undefined))
	tl.update()
}

function setupTimelineSticky(el) {
	const tl = timeline({
		beforeCalc: () => document.documentElement.classList.add('disable-scroll-cards'),
		afterCalc: () => document.documentElement.classList.remove('disable-scroll-cards'),
		start: () => positionInViewport(el, { elementY: 0, viewportY: 0 }).y,
		end: () => positionInViewport(el, { elementY: 1, viewportY: 1 }).y
	})
	const ease = el.getAttribute('data-scroll-position-ease') !== null
	tl.onUpdate((pos, details) => setVar(el, pos, ease ? easeInQuint : undefined))
	tl.update()
}

function setupTimelineToCentre(el) {
	const tl = timeline({
		beforeCalc: () => document.documentElement.classList.add('disable-scroll-cards'),
		afterCalc: () => document.documentElement.classList.remove('disable-scroll-cards'),
		start: () => positionInViewport(el, { elementY: 0, viewportY: 1 }).y,
		end: () => positionInViewport(el, { elementY: 1, viewportY: 0.5 }).y
	})
	const ease = el.getAttribute('data-scroll-position-ease') !== null
	tl.onUpdate((pos, details) => setVar(el, pos, ease ? easeInQuint : undefined))
	tl.update()
}

function setupTimelineHeroDefault(el) {
	const tl = timeline({
		beforeCalc: () => document.documentElement.classList.add('disable-scroll-cards'),
		afterCalc: () => document.documentElement.classList.remove('disable-scroll-cards'),
		start: () => positionInViewport(el, { elementY: 0, viewportY: 0.5 }).y,
		end: () => positionInViewport(el, { elementY: 0.7, viewportY: 0 }).y
	})
	const ease = el.getAttribute('data-scroll-position-ease') !== null
	tl.onUpdate((pos, details) => setVar(el, pos, ease ? easeInQuint : undefined))
	tl.update()
}

export default function init() {
	const els = [...document.querySelectorAll('.js-scroll-position')]
	els.map(setupTimeline)

	const stickyEls = [...document.querySelectorAll('.js-scroll-position--sticky')]
	stickyEls.map(setupTimelineSticky)

	const centreEls = [...document.querySelectorAll('.js-scroll-position--centre')]
	centreEls.map(setupTimelineToCentre)

	const heroDefaultEls = [...document.querySelectorAll('.js-scroll-position--hero-default')]
	heroDefaultEls.map(setupTimelineHeroDefault)
}
